import { ApiResponse, Meta, TicketManagerTicketStatus, TicketManagerStatusTransition } from '@vision/ui/interfaces';

export interface TicketManagerTicketStatusResponseDto {
  category: string;
  id: string;
  key: string;
  name: string;
  system: boolean;
}

interface TicketManagerStatusTransitionResponseDto {
  conditions?: Record<string, unknown>;
  from_status_id?: string;
  id: string;
  to_status_id?: string;
}

export function normalizeTicketManagerTicketStatus(
  status: TicketManagerTicketStatusResponseDto | TicketManagerTicketStatus | null | undefined,
): TicketManagerTicketStatus {
  if (!status) {
    throw new Error('Ticket status is null or undefined');
  }

  return {
    category: status.category,
    id: status.id,
    key: status.key,
    name: status.name,
    system: status.system,
  };
}

export function normalizeTicketManagerStatusTransition(
  transition: TicketManagerStatusTransitionResponseDto,
): TicketManagerStatusTransition {
  return {
    conditions: transition.conditions,
    fromStatusId: transition.from_status_id || '',
    id: transition.id,
    toStatusId: transition.to_status_id,
  };
}

export const normalizeTicketManagerTicketStatusesResponse = (
  response: ApiResponse<TicketManagerTicketStatusResponseDto[]>,
): ApiResponse<TicketManagerTicketStatus[]> => ({
  ...response,
  data: response.data.map((status) => normalizeTicketManagerTicketStatus(status)),
});

export const normalizeTicketManagerTicketStatusResponse = (
  response: ApiResponse<TicketManagerTicketStatusResponseDto>,
): ApiResponse<TicketManagerTicketStatus> => ({
  ...response,
  data: normalizeTicketManagerTicketStatus(response.data),
});

export const normalizeStatusTransitionsResponse = (
  response:
    | ApiResponse<TicketManagerStatusTransitionResponseDto[]>
    | { data: TicketManagerStatusTransitionResponseDto[]; meta?: Meta; url?: string },
): ApiResponse<TicketManagerStatusTransition[]> => {
  const normalized: ApiResponse<TicketManagerStatusTransition[]> = {
    data: Array.isArray(response?.data)
      ? response.data.map((transition) => normalizeTicketManagerStatusTransition(transition))
      : [],
    meta: 'meta' in response ? (response.meta ?? null) : null,
    object: 'collection',
  };

  return normalized;
};
